import React from 'react';
import './ModalPopup.css';

export default function ModalPopup({ children, onClose }) {
  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <button className="close-button" onClick={onClose}>&times;</button>
        {children}
      </div>
    </div>
  );
}